import {MainContainer} from "./Components.js"

function ChannelsTemplate({children, style, className}){
    return (
        <MainContainer style={style} className={className}>
            {children} 
        </MainContainer>
    )
}
export default ChannelsTemplate;